// @ts-nocheck
import { initialState, name } from "./reducer";

const loaders = (state) => state[name] || initialState;

export const isLoadingEnabled = (state, component) => loaders(state)?.[component]?.["isLoading"];
